/**
* AppointmentContent.js
* 
* Created on 11-sep-2017
*
* @author Olivier van der Pool for &ranj
**/

import { isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import ENGLanguagePackContentType from "./ENGLanguagePackContentType";

export default class AppointmentContent extends Content {
    constructor(
        languagePack,
        contentID,
        eventName,
        eventDescription,
        eventType,
        startTime,
        endTime,
        label
    ) {
        super(
            AppointmentContent.NAME,
            AppointmentContent.TYPE,
            label,
            languagePack,
            contentID
        );
        isUndefined(contentID) ? contentID = null : null;
        isUndefined(eventName) ? eventName = null : null;
        isUndefined(eventDescription) ? eventDescription = null : null;
        isUndefined(eventType) ? eventType = null : null;
        isUndefined(startTime) ? startTime = 0 : null;
        isUndefined(endTime) ? endTime = 0 : null;
        isUndefined(label) ? label = null : null;

        this._appointmentName = eventName;
        this._appointmentDescription = eventDescription;
        this._appointmentType = eventType;
        this._appointmentStartTime = startTime;
        this._appointmentEndTime = endTime;
    }

    setAppointmentStartTime(value) {
        this._appointmentStartTime = value;
    }

    getAppointmentStartTime() {
        return this._appointmentStartTime;
    }

    setAppointmentEndTime(value) {
        this._appointmentEndTime = value;
    }

    getAppointmentEndTime() {
        return this._appointmentEndTime;
    }

    getName() {
        return this.getLanguagePackContent(AppointmentContent.NAME_LABEL, ENGLanguagePackContentType.TEXT);
    }

    setName(value) {
        this.setLanguagePackText(AppointmentContent.NAME_LABEL, value);
    }

    getAppointmentName() {
        return this.getLanguagePackContent(AppointmentContent.APPOINTMENT_NAME_LABEL, ENGLanguagePackContentType.TEXT);
    }

    setAppointmentName(value) {
        this.setLanguagePackText(AppointmentContent.APPOINTMENT_NAME_LABEL, value);
    }

    getAppointmentType() {
        return this.getLanguagePackText(AppointmentContent.APPOINTMENT_TYPE_LABEL);
    }

    setAppointmentType(value) {
        this.setLanguagePackText(AppointmentContent.APPOINTMENT_TYPE_LABEL, value);
    }

    getAppointmentDescription() {
        return this.getLanguagePackText(AppointmentContent.APPOINTMENT_DESCRIPTION_LABEL);
    }

    setAppointmentDescription(value) {
        this.setLanguagePackText(AppointmentContent.APPOINTMENT_DESCRIPTION_LABEL, value);
    }

    convertToObject() {
        return this.getObject(["appointmentStartTime", "appointmentEndTime"]);
    }

    setPropertiesFromObject(object) {
        super.setPropertiesFromObject(object);
    }
}

AppointmentContent.NAME = "Appointment";
AppointmentContent.TYPE = "engAppointmentContent";

AppointmentContent.APPOINTMENT_NAME_LABEL = "appointmentName";
AppointmentContent.APPOINTMENT_DESCRIPTION_LABEL = "appointmentDescription";
AppointmentContent.APPOINTMENT_TYPE_LABEL = "appointmentType";